export function isPrimaryInsurance(activeCase, folder, field) {
    if (activeCase && activeCase[folder] && activeCase[folder].length > 0) {
        let main = activeCase[folder].find(item => field ? item[field] : item.is_primary_insurance)
        if (main) {
            return main
        } 
    }
    

    return null
}
export function isPrimaryLiablityAndNotDenied(activeCase, folder) {
    if (activeCase && activeCase[folder] && activeCase[folder].length > 0) {
        let main = activeCase[folder].find(item => item.is_primary_insurance && item.liability_status != 0)
        if (main) {
            return main
        } 
    }
    

    return null
}

export function returnPrimaryInsuranceOrTheNextActiveOne(activeCase, folder, field) {
    if (activeCase && activeCase[folder] && activeCase[folder].length > 0) {
        let main = activeCase[folder].find(item => field ? item[field] : item.is_primary_insurance)
        if (main) {
            return main
        } else {
            let firstActive = activeCase[folder].find(item => item.active)

            return firstActive
        }
    }
    

    return null
}

export function isManagingAttorney(activeCase) {
    if (activeCase && activeCase.attorneys && activeCase.attorneys.length > 0) {
        let main = activeCase.attorneys.find(item => item.is_managing_attorney)
        if (main) {
            return main
        } 
    }
    

    return false
}

export function returnManagingAttorneyOrTheNextActiveOne(activeCase) {
    if (activeCase && activeCase.attorneys && activeCase.attorneys.length > 0) {
        let main = activeCase.attorneys.find(item => item.is_managing_attorney)
        if (main) {
            return main
        } else {
            let firstActive = activeCase.attorneys.find(item => item.active)

            return firstActive
        }
    }
    

    return null
}